<button class="toggle-sidenav-btn" (click)="logout()" mat-icon-button>
  <app-svg-icon fill="drawer-button" icon="logout" size="small"></app-svg-icon>
</button>
